import Avatar from "@mui/material/Avatar"
import Menu from "@mui/material/Menu"
import { useState, useEffect } from "react"
import { ucfirst } from "../../../../helpers"
import styles from "./index.module.css"
import { logOut } from "../../../../modules/landing/authSlice"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import Badge from "@mui/material/Badge"
import Divider from "@mui/material/Divider"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisStrokeVertical } from "@fortawesome/pro-light-svg-icons"
import { faPenCircle } from "@fortawesome/sharp-duotone-solid-svg-icons"

const UserProfile = props => {
    const { userInfo, userRoles, isSideMenuExpanded, isHover, anchorEl, setAnchorEl } = props

    const navigate = useNavigate()
    const dispatch = useDispatch()
    // const [anchorEl, setAnchorEl] = useState(null)
    useEffect(() => {
        if (!isHover) {
            setAnchorEl(null)
        }
    }, [isHover, setAnchorEl])

    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleReports = () => {
        setAnchorEl(null)
        setTimeout(() => {
            navigate("/reports")
        }, 500)
    }

    const handleEditProfile = () => {
        navigate("/profile/my-profile")
    }

    return (
        <div className={isSideMenuExpanded || isHover ? styles.user_profile_expanded : styles.user_profile}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Avatar className={styles.avatar}>{userInfo.fullname ? ucfirst(userInfo.fullname[0]) : ""}</Avatar>
                {(isSideMenuExpanded || isHover) && <div className={styles.name}>{userInfo.fullname}</div>}
            </div>
            {(isSideMenuExpanded || isHover) && (
                <FontAwesomeIcon
                    onClick={e => handleClick(e)}
                    icon={faEllipsisStrokeVertical}
                    style={{
                        color: "#777776",
                        cursor: "pointer",
                    }}
                />
            )}

            <Menu
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: 200,
                    horizontal: 300,
                }}
                sx={{
                    "& .MuiPaper-root": {
                        padding: "12px",
                        borderRadius: "8px",
                    },
                    "& .MuiList-root": {
                        padding: "0px",
                        width: "226px",
                    },
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                {/* name section */}
                <div className={styles.top_container}>
                    <span className={styles.avatar_container}>
                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                            badgeContent={
                                <FontAwesomeIcon
                                    icon={faPenCircle}
                                    style={{
                                        "--fa-primary-color": "#ffffff",
                                        "--fa-secondary-color": "#f44c1e",
                                        "--fa-secondary-opacity": "1",
                                    }}
                                    onClick={() => handleEditProfile()}
                                />
                            }>
                            <Avatar onClick={e => handleClick(e)} className={styles.avatar}>
                                {userInfo.fullname ? ucfirst(userInfo.fullname[0]) : ""}
                            </Avatar>
                        </Badge>
                        <span className={styles.name}>
                            {userInfo.fullname ? userInfo.fullname.split(" ")[0] : userInfo.fullname}
                        </span>
                    </span>

                    {userRoles?.reports?.view && (
                        <span onClick={handleReports} className={styles.view_report_container}>
                            View Reports
                        </span>
                    )}
                </div>

                {/* Detail Section */}
                <div className={styles.details_container}>
                    <div className={styles.details_content}>
                        <span>Company Name:</span>
                        <span>{ucfirst(userInfo?.companyName)}</span>
                    </div>
                    <div className={styles.details_content}>
                        <span>Company Type:</span>
                        <span>{ucfirst(userInfo?.companyGroup)}</span>
                    </div>
                    <div className={styles.details_content}>
                        <span>Company Role:</span>
                        <span>{ucfirst(userInfo?.admin_role)}</span>
                    </div>
                </div>
                <Divider />
                {/* Logout Section */}
                <div
                    className={styles.logout_section}
                    onClick={() => {
                        dispatch(logOut())
                        localStorage.removeItem("isUserLoggedIn")
                        localStorage.removeItem("userInfo")
                        localStorage.removeItem("userRoles")
                        localStorage.removeItem("countryId")
                        navigate("/auth")
                    }}>
                    Logout
                </div>
            </Menu>
        </div>
    )
}

export default UserProfile
